<template>
    <div class="row">
        <div class="col-12">
            <div class="pull-right mb-4 mt-4" v-if="!showOnly">
                <button
                    @click.prevent="showModal"
                    class="btn btn-brand"
                    v-text="uLang('app.add_type', { type: uLang('app.log') })"
                ></button>
            </div>

            <logs-table
                :forceRefresh="forceRefresh"
                @refreshed="stopRefreshing"
                :api-url="logsTableApiUrl"
            />

            <b-modal
                class="log-modal-lg"
                :close-on-esc="false"
                :close-on-backdrop="false"
                :hideFooter="true"
                :title="uLang('app.add_type', { type: uLang('app.log') })"
                ref="logsModal"
                size="lg"
                v-if="($can('create-intern-logs')
                    || $can('update-intern-logs')
                    || $can('create-report-logs')
                    || $can('update-report-logs')
                    || $can('create-candidate-logs')
                    || $can('update-candidate-logs'))
                    && !showOnly"
            >
                <log-form
                    @logCreated="handleLogCreated"
                    @categoryChanged="handleCategoryChanged"
                    :key="logFormKey"
                    :entityType="entityType"
                    :entityId="entityId"
                    :overrideEndpoint="logsFormApiUrl"
                />
            </b-modal>
        </div>
    </div>
</template>
<script>
    import { LogsTable } from '~/components/tables'
    import { LogForm } from '~/components/forms'

    export default {
        name: "LogsTab",

        components: {
            LogsTable,
            LogForm,
        },

        props: {
            entityType: {
                type: String,
                required: true,
            },
            entityId: {
                type: Number,
                required: true,
            },
            showOnly: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                category_id: null,
                forceRefresh: false,
                logFormKey: 0
            }
        },

        computed: {
            logsFormApiUrl() {
                return route('logs.store', {
                    category: this.category_id,
                })
            },
            logsTableApiUrl() {
                let singularEntityType = this.entityType.substring(0, this.entityType.length - 1)
                return route(this.entityType + '.logs.table', {
                    [singularEntityType]: this.entityId,
                })
            },
        },

        methods: {
            handleLogCreated() {
                this.$refs.logsModal.hide();
                this.forceRefresh = true
            },

            handleCategoryChanged(category_id) {
                this.category_id = category_id
            },

            stopRefreshing() {
                this.forceRefresh = false
            },

            showModal() {
                this.logFormKey += 1
                this.$refs.logsModal.show()
            }
        }
    }
</script>
<style lang="css">
    .log-modal-lg .modal .modal-dialog.modal-lg {
        max-width: 1000px;
    }
</style>
